import { useContext, useState } from 'react'
import { GlobalContext } from 'App'
import Header from 'components/Header/Header'
import './style.css'
import { FullpageContainer, FullpageSection } from '@shinyongjun/react-fullpage'
import '@shinyongjun/react-fullpage/css'
import First from 'components/About/Fisrt'
import AboutBg from 'assets/About/about.avif'
import AboutMo from 'assets/About/aboutMo.avif'
// import Second from 'components/About/Second'
// import SecondMo from 'components/About/SecondMo'

const About = () => {
  const { isTablet } = useContext(GlobalContext)
  const [activeIndex, setActiveIndex] = useState<number>(0)

  return (
    <>
      <Header isOverLay={false} />

      <div className={`flex w-full h-screen overflow-hidden justify-center items-center bg-black select-none`}
        style={{
          backgroundImage: `url(${isTablet ? AboutMo : AboutBg})`,
          backgroundSize: 'cover', // 이미지 크기 조정
          backgroundPosition: 'center', // 이미지 위치
          backgroundRepeat: 'no-repeat', // 이미지 반복 제거
          width: '100%',
          height: 'calc(var(--vh, 1vh) * 100)', // 원하는 높이 설정
        }}>
        <FullpageContainer
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}>
          <FullpageSection>
            <First />
          </FullpageSection>
          {/* <FullpageSection>
            {
              isTablet ?
                <SecondMo /> :
                <Second />
            }
          </FullpageSection> */}
        </FullpageContainer>
      </div>
    </>
  )
}

export default About
